const subscribeToUserActionsWatchedResponse = userActionsWatchedResponse$ =>
    userActionsWatchedResponse$
        .subscribe();

export default subscribeToUserActionsWatchedResponse;
